var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{style:([{ 'background-color': _vm.webSettings.bodyColor }])},[(_vm.notFound)?_c('NotFoundView'):_vm._e(),(!_vm.notFound)?_c('HomeView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }